'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncGeneratorDelegate = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var pushable = require('it-pushable');
/**
 * Treat one or more iterables as a single iterable.
 *
 * Nb. sources are iterated over in parallel so the
 * order of emitted items is not guaranteed.
 *
 * @template T
 * @param {...AsyncIterable<T>|Iterable<T>} sources
 * @returns {AsyncIterable<T>}
 */


var merge = /*#__PURE__*/function () {
  var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var _len,
        sources,
        _key,
        output,
        _args3 = arguments;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            for (_len = _args3.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
              sources[_key] = _args3[_key];
            }

            output = pushable();
            setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.prev = 0;
                      _context2.next = 3;
                      return Promise.all(sources.map( /*#__PURE__*/function () {
                        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
                          var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;

                          return _regeneratorRuntime.wrap(function _callee$(_context) {
                            while (1) {
                              switch (_context.prev = _context.next) {
                                case 0:
                                  _iteratorAbruptCompletion = false;
                                  _didIteratorError = false;
                                  _context.prev = 2;
                                  _iterator = _asyncIterator(source);

                                case 4:
                                  _context.next = 6;
                                  return _iterator.next();

                                case 6:
                                  if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                                    _context.next = 12;
                                    break;
                                  }

                                  item = _step.value;
                                  output.push(item);

                                case 9:
                                  _iteratorAbruptCompletion = false;
                                  _context.next = 4;
                                  break;

                                case 12:
                                  _context.next = 18;
                                  break;

                                case 14:
                                  _context.prev = 14;
                                  _context.t0 = _context["catch"](2);
                                  _didIteratorError = true;
                                  _iteratorError = _context.t0;

                                case 18:
                                  _context.prev = 18;
                                  _context.prev = 19;

                                  if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                                    _context.next = 23;
                                    break;
                                  }

                                  _context.next = 23;
                                  return _iterator.return();

                                case 23:
                                  _context.prev = 23;

                                  if (!_didIteratorError) {
                                    _context.next = 26;
                                    break;
                                  }

                                  throw _iteratorError;

                                case 26:
                                  return _context.finish(23);

                                case 27:
                                  return _context.finish(18);

                                case 28:
                                case "end":
                                  return _context.stop();
                              }
                            }
                          }, _callee, null, [[2, 14, 18, 28], [19,, 23, 27]]);
                        }));

                        return function (_x) {
                          return _ref3.apply(this, arguments);
                        };
                      }()));

                    case 3:
                      output.end();
                      _context2.next = 9;
                      break;

                    case 6:
                      _context2.prev = 6;
                      _context2.t0 = _context2["catch"](0);
                      output.end(_context2.t0);

                    case 9:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2, null, [[0, 6]]);
            })), 0);
            return _context3.delegateYield(_asyncGeneratorDelegate(_asyncIterator(output), _awaitAsyncGenerator), "t0", 4);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function merge() {
    return _ref.apply(this, arguments);
  };
}();

module.exports = merge;